import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/social/react-youtube/src/youtube-video.tsx");
